<template>
  <div class="product-com" :style="style">
    <img v-if="product.isCooperation" class="cooperate-img" src="@/assets/home/cooperate-icon.png" alt="">
    <div class="product-top" @click.stop="goProductDetail">
      <div class="product-top-info flex p-14">
        <!-- <a-image
          :width="60"
          :height="60"
          :preview="false"
          style="border-radius: 4px"
          :src="product.absoluteThumbnailUrl"
        /> -->
        <img style="width:60px;height:60px;border-radius: 4px;" :src="product.absoluteThumbnailUrl" alt="">
        <div class="product-info ml-8">
          <div class="product-name text-base font-bold text-left">
            {{product.productName}}
          </div>
          <div class="product-price flex items-center">
            <div class="unmemberrship-price-tip" v-if="!product.price">
              暂未报价
            </div>
            <template v-else>
              <div v-if="product.vipPrice" class="flex items-baseline">
                <div class="unmemberrship-price-tip price-red">专享价</div>
                <!-- <div class="memberrship-price-tip">零售价</div> -->
                <div class="ml-4 mr-4 memberrship-price">¥{{toFixed2(product.vipPrice)}}</div>
                <div class="unmemberrship-price-tip">/{{product.unitName}}{{product.priceType=='LADDER'?'起':''}}</div>
              </div>
              <div v-else class="flex items-baseline">
                <div class="unmemberrship-price-tip">零售价</div>
                <!-- <div class="memberrship-price-tip">零售价</div> -->
                <div class="ml-4 mr-4 memberrship-price">¥{{toFixed2(product.price)}}</div>
                <div class="unmemberrship-price-tip">/{{product.unitName}}{{product.priceType=='LADDER'?'起':''}}</div>
              </div>
            </template>
            
          </div>
        </div>
      </div>
      <div
        class="product-view-price mb-14 ml-14 flex items-center"
      >
        大宗采购低于市场价
        <!-- 20% -->
      </div>
      <div v-if="!product.price" class="product-buy-btn-box align-center flex justify-between">
        <div class="product-buy-fill-btn mb-14 ml-14 align-center justify-center flex w-120"  @click.stop="inquireFun(product.supplierId)">我要询价</div>
      </div>
      <div v-else class="product-buy-btn-box align-center flex justify-between">
        <div class="product-buy-btn mb-14 ml-14 align-center justify-center flex" :class="{'disabled':userInfo.isSupplier}">
          <AddCartButton v-if="!userInfo.isSupplier" @addParentCart="addProductCart" :product="{...product,src:product.absoluteThumbnailUrl}">加入购物车</AddCartButton>
          <div v-else class="disabled-cart">加入购物车</div>
        </div>
        <div class="product-buy-btn mb-14 ml-14 align-center justify-center flex" @click.stop="inquireFun(product.supplierId)">我要询价</div>
      </div>
    </div>
    <div class="product-btm flex items-center" @click.stop="goProductStore">
      <img src="@/assets/home/store-icon.png" class="supplier-img mr-6" />
      <span>{{product.supplierName}}</span>
    </div>
  </div>
  
</template>
<script setup>
import { ref, computed } from "vue";
import { useRouter } from 'vue-router'
import { RightOutlined } from "@ant-design/icons-vue";
import AddCartButton from "@/components/com/addCartButton.vue"
import _ from "lodash"
import { useStore } from 'vuex'
import api from '@/net/api'
import { message } from "ant-design-vue";
const store = useStore()
const userInfo = computed(() => store.state.user.userInfo)
const productsCart = computed(() => store.state.productsCart.productsCart)
const router = useRouter()
const props = defineProps({
  product: {
    required: true, // 是否必传
    type: Object,
    default: () => {}
  },
  style:{
    required: false, // 是否必传
    type: Object,
    default: () => {}
  }
})
function addProductCart(product){
  let _productsCart = _.cloneDeep(productsCart.value)
  let { supplierId, supplierName, deliveryFee, minDeliveryAmount } = product
  let productId = userInfo.value.isCollege?product.productId:product.id
  let index = _productsCart.findIndex(item=>item.supplierId === supplierId)
  if( index>-1 ){
    let pIndex =  _productsCart[index].productList.findIndex(pItem=>pItem.productId === productId)
    if(pIndex > -1){
      if(product.minimumCount>1){
        _productsCart[index].productList[pIndex].count = _productsCart[index].productList[pIndex].count + product.minimumCount
      }else{
        _productsCart[index].productList[pIndex].count = _productsCart[index].productList[pIndex].count + 1
      }
    }else{
      _productsCart[index].productList.push({count:product.minimumCount,...product,productId,checked:false,isInValid: false,})
    }
  }else{
    _productsCart.push({
      supplierId,supplierName,indeterminate: false,isInValid: false,deliveryFee, minDeliveryAmount,_deliveryFee:deliveryFee,
      checkAll: false,productList:[{count:product.minimumCount,...product,productId,checked:false,isInValid: false,}]
    })
  }
  store.dispatch('set_productsCart',_productsCart)
  // console.log('添加到购物车的操作',_productsCart)
}
// 去店铺
function goProductStore(){
  if(props.product.supplierId){
    router.push('/main/store/detail?id='+props.product.supplierId)
  }else{
    message.warning('跳转失败，请重试')
  }
}
// 商品详情
function goProductDetail(){
  if(props.product.id && props.product.supplierId){
    router.push('/main/productInfo?id='+props.product.id+'&storeId='+props.product.supplierId)
  }else{
    message.warning('跳转失败，请重试')
  }
}
// 我要询价
function inquireFun(supplierId){
  api.info_supplier_getUserSign({supplierId}).then((res) => {
    console.log(res)
    router.push('/main/personalCenter/message?code='+res)
  })
  
}
</script>
<style lang="scss" scoped>
@import "./style/recentBuyProductCom.scss";
</style>
